import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import ReactPlayer from 'react-player'
import { MapInteraction, MapInteractionCSS } from 'react-map-interaction';

import AppContext from '../AppContext';

const localization = {
    ua: {
        attachmentDelete: 'Видалити',
    },
    ru: {
        attachmentDelete: 'Удалить',
    },
    en: {
        attachmentDelete: 'Delete',
    },
}

class Preview extends React.Component {
    static contextType = AppContext;
    
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            ext: null,
            name: null,

            value: {
                scale: 1,
                translation: { x: 0, y: 0 }
            },

            fixed: true,
        }

        this.img = React.createRef();
        this.fix = this.fix.bind(this);
    }

    componentDidMount() {
        var ext = this.props.src.split(".")[1];
        var p = this.props.src.split("/");

        this.setState({
            isLoading: false, 
            ext: ext,
            name: p[p.length-1],
        });
    }

    imgLoaded() {
        const { scale, height, width } = this.context;

        var x = (width - this.img.current.width) / 2;
        var y = (height - this.img.current.height) / 2;

        this.setState({
            value: {
                scale: 1,
                translation: { 
                    x: scale != "xs" ? x : 0, 
                    y: scale != "xs" ? y > 0 ? y : 0 : y             
                }
            }
        }, () => {
            console.log(this.img.current.height);
            console.log(this.img.current.width);

            console.log(this.state.value.translation.x);
            console.log(this.state.value.translation.y);
        });
    }

    fix() {
        this.setState({fixed: !this.state.fixed});
    }

    render() {
        const {scale, lang} = this.context;

        if (this.state.Loading) {
            return (
                <div class="card mb-2">
                    
                </div>
            )
        }

        if (this.state.ext == "mp4") {
            return (
                <div class="card mb-2">
                    <ReactPlayer className="card-img" width="100%" height="100%" 
                        url={this.props.src} 
                        controls={true} 
                        pip={false} 
                        
                        config={{
                            file: {
                                attributes: {
                                    controlsList: 'nodownload',
                                    disablepictureinpicture: 'true'
                                } 
                            } 
                        }}
                    />
                    {/* <img src={this.props.src} class="card-img" alt="..."/> */}
                    <div style={{zIndex: "1", position: "absolute", left: "0px", top: "0px", right: "0px", paddingTop: "5px", paddingRight: "5px", height: "50px", textAlign: "right"}}>
                        {this.props.removeFile != null && (
                            <button className="btn-agis-hover" style={{height: "20px", fontSize: "10px"}} onClick={this.props.removeFile}>{localization[lang].attachmentDelete} <FontAwesomeIcon icon={faTimes} className="ml-1" style={{fontSize: "8px"}}/></button>
                        )}
                    </div>
                </div>
            )
        }

        if (this.state.ext == "pdf") {
            return (
                <div class="card mb-2">
                    <big style={{paddingLeft: "8px", lineHeight: "50px"}}>
                        <FontAwesomeIcon icon={faFilePdf} className='text-danger'/>
                        <a href={this.props.src} target="_blank" className='ml-2' download>{this.state.name}</a>
                    </big>
                    {/* <img src={this.props.src} class="card-img" alt="..."/> */}
                    <div style={{zIndex: "1", position: "absolute", top: "0px", right: "0px", paddingTop: "5px", paddingRight: "5px", height: "50px", width: "108px", textAlign: "right"}}>
                        {this.props.removeFile != null && (
                            <button className="btn-agis-hover" style={{height: "20px", fontSize: "10px"}} onClick={this.props.removeFile}>{localization[lang].attachmentDelete} <FontAwesomeIcon icon={faTimes} className="ml-1" style={{fontSize: "8px"}}/></button>
                        )}
                    </div>
                </div>
            )
        }

        return (
            <div class="card mb-2">
                <div className={this.state.fixed ? "d-none" : "fixed-bottom d-flex align-items-center justify-content-center"} style={{zIndex: 2000, height: "100%", backgroundColor: "#000000d4"}}>
                    <div className="fixed-top d-flex align-items-center justify-content-end pt-3 pr-3" style={{zIndex: "4"}}>
                        <span onClick={this.fix} style={{fontSize: "1rem", color: "#dcdcdc"}}>
                            <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10 fa-2x"><path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z" class=""></path></svg>
                        </span>
                    </div>

                    <MapInteractionCSS value={this.state.value} onChange={(value) => this.setState({value})}>
                        <img ref={scale != "xs" && this.img} src={this.props.src} onLoad={this.imgLoaded.bind(this)} className="card-img" alt="..." />
                    </MapInteractionCSS>
                </div>

                <img ref={scale == "xs" && this.img} onClick={this.fix} src={this.props.src} class="card-img" alt="..."/>
                {this.props.removeFile != null && (
                    <div style={{zIndex: "1", position: "absolute", left: "0px", top: "0px", right: "0px", paddingTop: "5px", paddingRight: "5px", height: "50px", textAlign: "right"}}>
                        <button className="btn-agis-hover" style={{height: "20px", fontSize: "10px"}} onClick={this.props.removeFile}>{localization[lang].attachmentDelete} <FontAwesomeIcon icon={faTimes} className="ml-1" style={{fontSize: "8px"}}/></button>
                    </div>
                )}
            </div>
        )
    }
}

export default Preview;